import Styles from '../../../../ArticlesComponents/ArticleWrapper/styles.module.scss';

export default function AboutUs() {
  return (
    <p>
      We are <span className={Styles.important}>City Falcon Limited</span> (the <span className={Styles.important}>"Information Service Provider"</span>).
      We are registered in England and Wales under company number 09107763 and our main trading address is Level39, One Canada Square, Canary Wharf, London E14 5AB.  Our VAT number will be notified to customers appropriately. We are a limited company.
      <br /><br />
      We host and provide access to the Services (defined and described below) via our API infrastructure.
      <br /><br />
      If you wish to give us formal notice of any matter in accordance with the Contract for Services, please see the Notices section below.
    </p>
  );
}
